module.exports = __webpack_public_path__ + "static/media/information-nocolor.723796fd.svg";